export default {
  "title": "Chiến Nào, Ma Kia!",
  "intro": "Tích lũy mốc Điểm Chung Sức yêu cầu để nhận thưởng tương ứng. Góp càng nhiều, quà càng ngon!",
  "login": "Đăng nhập",
  "logout": "Đăng Xuất",
  "howToPlay": "Chi tiết SK",
  "contributeDesc": "Tích lũy mốc Điểm Chung Sức yêu cầu để nhận thưởng tương ứng. Góp càng nhiều, quà càng ngon!",
  "account": "ID tài khoản",
  "code": "Mã xác minh",
  "sendCode": "Gửi mã qua [Thư]",
  "codeSent": "Đã gửi mã xác thực, vui lòng kiểm tra [Thư]",
  "submit": "Xác nhận",
  "cancel": "Huỷ",
  "ok": "OK",
  "rewardConfirm": "Xác nhận",
  "available": "Số Tên Lửa còn lại",
  "total": "Tổng lượt đánh",
  "ghostDefeated": "Ma đã bị hạ gục",
  "globalTitle": "Tiến Độ Chiến Ma",
  "strikeTitle": "Đánh",
  "strike": "Khai hoả!!!",
  "strikeRecord": "Khai hoả",
  "taskTitle": "Đấu Trường Quyết Chiến",
  "missionClaimed": "Đã nhận",
  "missionCompleted": "Mở khoá",
  "missionIncomplete": "Khoá",
  "share": "Chia sẻ",
  "sharing": "Đang chia sẻ",
  "shareOk": "Đã chia sẻ",
  "milestoneTitle": "Mốc cá nhân",
  "times": "Lần",
  "recordTitle": "Lịch sử nhận Thưởng",
  "recordDialogTitle": "Lịch sử nhận Thưởng",
  "recordReward": "Phần Thưởng",
  "recordTime": "Thời Khắc Cống Hiến",
  "refresh": "Làm mới",
  "empty": "Chưa có dữ liệu",
  "receive": "Mở khoá",
  "received": "Đã nhận",
  "notReady": "Khoá",
  "locked": "Chưa mở",
  "unlocked": "Mở khoá",
  "rewardTitle": "Phần thưởng",
  "phase": {
    "not_start": "Sự kiện chưa bắt đầu",
    "play": "Sự kiện đang diễn ra",
    "view_only": "Sự kiện đã kết thúc",
    "closed": "Trang đã đóng"
  },
  "actTime": {
    "notStart": "Sự kiện chưa bắt đầu",
    "ended": "Sự kiện đã kết thúc",
    "startCountdown": "Đếm ngược đến khi bắt đầu",
    "day": "Ngày"
  },
  "taskCycle": {
    "daily": "Nhiệm vụ hàng ngày",
    "weekly": "Nhiệm vụ Tuần"
  },
  "tasks": {
    "hw_daily_login": "Đăng nhập mỗi ngày",
    "hw_daily_play_any_1": "Hoàn thành 1 trận ở chế độ bất kỳ",
    "hw_daily_play_any_3": "Chơi 3 trận bất kỳ",
    "hw_daily_mojin_3": "Hoàn thành 3 trận TKKB",
    "hw_weekly_share": "Chia sẻ lên MXH"
  },
  "props": {
    "90301916": "[Khung Avatar] Sugar Bomb",
    "70100101": "Kim Cương Vàng",
    "70100011": "Xu Vàng",
    "50108900": "Canorus (3 ngày)",
    "70100004": "Vé Điểm",
    "80103001": "Rank Protection",
    "10301029": "Lưỡi Liềm-Phán Quyết Tử Thần (3 ngày)",
    "80102101": "Vé quay Kim Cương Vàng",
    "82101002": "Flower",
    "80202003": "Thẻ nâng cấp VK Lv.3",
    "82101003": "Lollipop",
    "81010999": "Xu tăng trưởng Đa năng",
    "70100013": "Mystic Voucher",
    "70100014": "Chìa Khoá Bí Bảo",
    "10101086": "AK15-Thần Mùa Màng"
  },
  "footer": {
    "privacyPolicy": "Chính sách quyền riêng tư",
    "userAgreement": "Thỏa thuận người dùng",
    "customerService": "Vui lòng liên hệ với chúng tôi qua email ministarcustomerservice{'@'}gmail.com"
  },
  "error": {
    "code401": "Phiên đăng nhập hết hạn",
    "code1001": "Tham số không hợp lệ",
    "code1004": "Vui lòng thử lại",
    "code2001": "Sự kiện chưa bắt đầu",
    "code2002": "Sự kiện đã kết thúc",
    "code2003": "Trang đã đóng",
    "code2201": "Nhiệm vụ chưa hoàn thành",
    "code2202": "Phần thưởng đã nhận",
    "code2203": "Nhiệm vụ chưa cấu hình",
    "code2301": "Không còn lượt đánh",
    "code2401": "Chưa mở khoá mốc",
    "code2402": "Phần thưởng đã nhận",
    "code2403": "Không tìm thấy mốc",
    "code2501": "Chưa đạt điều kiện mốc thưởng",
    "code2502": "Đã nhận mốc thưởng",
    "code2503": "Không tìm thấy mốc",
    "code2801": "Phần thưởng đã nhận",
    "code429": "Thao tác quá nhanh"
  },
  "howToPlayBody": "🎃 [Chiến Nào, Ma Kia!] Đồng đội cùng lên đồ, Chiến Ma săn Quà khủng\n\nVào đêm Halloween, một Hồn Ma khổng lồ xâm nhập vào thế giới Mini World Royale, nhũng nhiễu làm náo loạn toàn chiến trường! Tom, Nona, Lăng Vũ và Cơ Giáp Tinh Vân kêu gọi tất cả các Xạ thủ trên toàn server hợp lực đánh bại Boss Hồn Ma để bảo vệ Đêm Halloween náo nhiệt!\n\n📅 Thời gian Sự kiện\nThời gian tham gia: 23/10 – 09/11\nNhận thưởng / Đổi quà: Từ khi bắt đầu sự kiện đến hết ngày 16/11\nLưu ý: Nhớ nhận phần thưởng trong thời gian quy định, quá hạn sẽ tính là tự động từ bỏ đó!\n\n🔥 Hướng dẫn 3 BƯỚC ĐÁNH BẠI Boss Hồn Ma\n\nBước 1: Nhận Đạn\nTruy cập chế độ [Đấu Trường Quyết Chiến], hoàn thành nhiệm vụ Hàng ngày/tuần để nhận lượt tấn công!\n\nBước 2: Khai hoả chiến Hồn Ma!\nNhấn vào nút [Khai Hỏa] để thực thi công lý! \nMỗi lượt bắn sẽ trừ thẳng vào máu Boss Hồn Ma toàn server và tích lũy điểm cống hiến cá nhân. Hãy cùng các thợ săn chung sức \"hút máu\" Boss Hồn Ma nhé! (Lượt bắn chưa dùng sẽ được cộng dồn sang ngày hôm sau).\n\nBước 3: Mở khóa phần thưởng\nThưởng Toàn Server: Đạt mốc 25% / 50% / 75% / 100% hút máu Boss, toàn bộ chiến binh tham gia sẽ mở khóa quà tương ứng. Hạ gục Boss thành công, nhận ngay Quà Toàn Server!\nThưởng Cá Nhân: Tích lũy điểm cống hiến để mở khóa các mốc quà riêng. Khai hoả càng nhiều, thưởng càng lớn!\n\n🏆 Nhật ký của tôi\nMọi [Lượt tấn công] và phần thưởng đã nhận đều có thể xem lại trong mục \"Lịch Sử Nhận Thưởng\".",
  "shareTitle": "Cho Kẹo Hay Bị Ghẹo!!!",
  "shareContent": "Đánh bại Hồn Ma - cùng cả server ăn mừng Halloween diệu kỳ. \nPhần thưởng tới tay, giữ cho thật chắc!",
  "accountPlaceholder": "Nhập tài khoản",
  "codePlaceholder": "Nhập mã xác minh"
}
